module.exports = __webpack_public_path__ + "img/1.adb0a036.svg";